module.exports = __webpack_public_path__ + "img/share.6408d5bb.png";